import Account from '@/helper/AccountHelper.js'
import BzbsApi from '@/core/Http/BzbsApi.js'
import Cache from '@/helper/Cache.js'
import Vue from 'vue'

/**
 * @method apiBeeRewardSetting
 */
export default {
  config: function () {
    return Vue.bzbsConfig
  },
  token: function () {
    return Account.getCacheToken() ? Account.getCacheToken() : null
  },
  app_id: function () {
    if (Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')) != null) {
      if (
        Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId !=
        undefined
      ) {
        return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId
      } else {
        return Account.getCacheCustom('app_id')
      }
    } else {
      return Account.getCacheCustom('app_id')
    }
  },

  apiBeeRewardSetting: function () {
    var data = {
      appId: this.app_id(),
      returnUrl: '',
    }
    var param = {
      data: JSON.stringify(data),
    }
    var url = this.config().bzbsBeeRewardUrl + '/setting'
    return BzbsApi.connectBzbsPostAppId(url, this.token(), param, null, null)
  },
}
